import React, { useState } from 'react';
import axios from 'axios';

const SliderImageUpload = () => {
    const [images, setImages] = useState([]);
    const [captions, setCaptions] = useState([]);
    const [details, setDetails] = useState([]);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    // Handle changes in image selection
    const handleImageChange = (e) => {
        setImages(e.target.files);
        setCaptions(Array(e.target.files.length).fill(''));
        setDetails(Array(e.target.files.length).fill(''));
    };

    // Update captions based on index
    const handleCaptionChange = (index, value) => {
        const newCaptions = [...captions];
        newCaptions[index] = value;
        setCaptions(newCaptions);
    };

    // Update details based on index
    const handleDetailChange = (index, value) => {
        const newDetails = [...details];
        newDetails[index] = value;
        setDetails(newDetails);
    };

    // Submit form data
    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validate input data
        if (images.length === 0) {
            setError('Please select at least one image.');
            return;
        }
        if (captions.some(caption => caption.trim() === '') || details.some(detail => detail.trim() === '')) {
            setError('Please provide captions and details for all images.');
            return;
        }

        const formData = new FormData();
        for (let i = 0; i < images.length; i++) {
            formData.append('images', images[i]);
            formData.append('captions', captions[i]);
            formData.append('details', details[i]);
        }

        try {
            const response = await axios.post('http://121.52.154.120:3001/api/upload-slider-images', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            setMessage('Images uploaded successfully');
            setError('');
            console.log(response.data.sliderImages);
        } catch (error) {
            console.error('An error occurred while uploading images:', error);
            setError('Upload failed. Please try again.');
        }
    };

    return (
        <div>
            <h1>Upload Slider Images</h1>
            <form onSubmit={handleSubmit}>
                <input type="file" multiple onChange={handleImageChange} />
                {Array.from({ length: images.length }).map((_, index) => (
                    <div key={index}>
                        <input
                            type="text"
                            placeholder="Caption"
                            value={captions[index] || ''}
                            onChange={(e) => handleCaptionChange(index, e.target.value)}
                        />
                        <input
                            type="text"
                            placeholder="Detail"
                            value={details[index] || ''}
                            onChange={(e) => handleDetailChange(index, e.target.value)}
                        />
                    </div>
                ))}
                <button type="submit">Upload</button>
            </form>
            {message && <p style={{ color: 'green' }}>{message}</p>}
            {error && <p style={{ color: 'red' }}>{error}</p>}
        </div>
    );
};

export default SliderImageUpload;
